import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FFPaper from '../../shared/FFPaper';
import * as React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import Title from '../../shared/Title';
import { FunctionComponent } from 'react';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import ChartContainer from '../../shared/ChartContainer';

const handler = (menu: string) => {
  console.log(menu);
}

const chartData = [
    { name: 'Female', value: 38, color: '#21539B' },
    { name: 'Male', value: 58, color: '#A0D5FF' },
    { name: 'Not specified', value: 4, color: '#218FE6' },
];

const COLORS = ['#21539B', '#A0D5FF', '#218FE6'];
const RADIAN = Math.PI / 180;


type CircleLegendProps = {
    label: string,
    color: string,
    value: string
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color, value }) => {
    return (
        <Stack direction="column" sx={{ alignItems: 'left' }} spacing={1}>
            <Stack direction="row" sx={{
                padding: '2px 10px 2px 10px',
            }}>
                <Box sx={{
                    width: 22,
                    borderRadius: '50%',
                    height: 20,
                    backgroundColor: color,
                }}>&nbsp;
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: 200
                }}>
                <Typography sx={{
                    padding: '0px 10px 10px 20px',
                    color: 'grey.800',
                }}>
                    {label}
                </Typography>

                <Typography sx={{
                    padding: '0px 10px 10px 20px',
                    color: 'grey.800',
                }}>
                    {value}
                </Typography>
                </Box>
            </Stack>
        </Stack>
    )
}


const renderCustomizedLabel = (data: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {

    const radius = data.innerRadius + (data.outerRadius - data.innerRadius) * 0.5;
    const x = data.cx + radius * Math.cos(-data.midAngle * RADIAN);
    const y = data.cy + radius * Math.sin(-data.midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central" fontSize={11} >
            {`${(data.percent * 100).toFixed(0)}%`}
        </text>
    );
};


function WeekTrafficPieChart() {

    const renderLegend = (props: any) => {
        const { payload } = props;

        return (
            <Box sx={{
                pl: {
                    xs: '0',
                    sm: '45%',
                    md: '50%'
                },
                pt: {
                    xs: '0%',
                    sm: '0%',
                    md: '0%'
                },
                mt: {
                    xs: 4,
                    sm: -18,
                    md: -18
                }
            }}>
                {
                    payload.map((entry: any, i:number) => {
                        const { payload: item } = entry;
                        return (
                                <CircleLegend key={i} label={item.name} color={item.color} value={item.value} />
                        )
                    })
                }
            </Box>
        )
    }

    return (
        <React.Fragment>
            <ResponsiveContainer >
                <PieChart  >
                    <Pie
                        data={chartData}
                        labelLine={false}
                        innerRadius={25}
                        outerRadius={80}
                        cy={90}
                        cx={140}
                        dataKey="value"
                        label={renderCustomizedLabel}

                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Legend content={renderLegend} />
                </PieChart>
            </ResponsiveContainer>
        </React.Fragment>
    );
}


export default function TrafficByGenderDemographicsCard() {

    return (

        <Grid item={true} xs={12} md={12} lg={12} xl={11}
        sx={{
            mt: {
                xs: 2,
                md: 2,
                lg: 2
            }
        }}
            >
            <FFPaper
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    pb: 3,
                    position: 'relative',
                    justifyContent: 'top',
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />
                <Box sx={{
                    p: '10px'
                }}>
                    <Title big={true} notooltip={true}>Traffic by Gender</Title>
                </Box>
                <Box sx={{ 
                    minHeight: {
                        xs: 320,
                        sm: 200,
                        md: 200
                    }
                    , height: '100%', display: 'flex', justifyContent: 'center', width: '100%'}}>
                    <Box sx={{ width: '90%', maxWidth: 650 }}>
                        <ChartContainer>
                            <WeekTrafficPieChart />
                        </ChartContainer>
                    </Box>
                </Box>
            </FFPaper>
        </Grid>

    )

}
